import { render, staticRenderFns } from "./category-card.vue?vue&type=template&id=0e5342d4&scoped=true"
import script from "./category-card.vue?vue&type=script&lang=js"
export * from "./category-card.vue?vue&type=script&lang=js"
import style0 from "./category-card.vue?vue&type=style&index=0&id=0e5342d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5342d4",
  null
  
)

export default component.exports